const Referral = () => {
    window.location.href = 'https://www.keyframesports.com';
    return null;
};

export default Referral;



// WEBPACK FOOTER //
// ./src/App/Referral.tsx